@use '@/sass/variables';

.timePickerNative {
  padding: variables.$spacing-extra-small variables.$spacing-medium;
  border: 1px solid variables.$gray;
  border-radius: variables.$border-radius-1;
  font-size: variables.$font-size-6;
  font-family: inherit;
  width: 120px;
  box-shadow: 0 0 0 1px variables.$black-05;
  &::-webkit-calendar-picker-indicator {
    cursor: pointer;
  }
}
